import Vue from 'vue';
import DataTable from 'primevue/datatable';

Vue.component('DataTable', DataTable);
